import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import {GetSelected} from "../../../../common/tableHandler/manipulateTable";

export default function standart() {}

export const FillTableCallBack = (result, page_number, columnList, isFilterCallFormMap) => {
  var oTable = $("#example").dataTable();
  if (page_number == 1) oTable.fnClearTable();
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      $.each(result.data, function (index, data) {
        var checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';
        var circleType;
        if (data.content["status-beheeractiviteit"] === true) {
          circleType =
            '<div class="green-circle rounded-circle"><span class="tooltiptext">Beheerobject heeft een maatregel.</span></div>';
        } else if (data.content["status-beheeractiviteit"] === false) {
          circleType =
            '<div class="red-circle rounded-circle"><span class="tooltiptext">Beheerobject heeft geen maatregel.</span></div>';
        } else if (data.content["status-beheeractiviteit"] === undefined) {
          circleType =
            '<div class="green-circle rounded-circle"><span class="tooltiptext">Beheerobject heeft een maatregel.</span></div>';
        }
        var algemeenGisratioid =
          '<span class="text-dark font-weight-bold">' +
          data.content["algemeen-gisratioid"] +
          "</span>";
        var beheereenheidNaam =
          '<a href="javascript:void(0)">' +
          data.content["beheereenheid-naam"] +
          "</a>";
        var disNaam = data.content["discipline-naam"];
        if (typeof disNaam === "undefined") {
          disNaam = "";
        }

        var horizon = "";
        var startDate = "";
        var endDate = "";
        if (typeof data.content["algemeen-horizon"] !== "undefined") {
          startDate = Common.FormatDate(
            data.content["algemeen-horizon"][0],
            "date"
          );
          endDate = Common.FormatDate(
            data.content["algemeen-horizon"][1],
            "date"
          );
          horizon = startDate + " " + endDate;
        }

        var gebiedLaag = data.content["algemeen-laag"];
        if (typeof gebiedLaag === "undefined") {
          gebiedLaag = "";
        }
        var algemeenPrestatie = data.content["algemeen-prestatie"];
        if (typeof algemeenPrestatie === "undefined") {
          algemeenPrestatie = "";
        } else {
          algemeenPrestatie = algemeenPrestatie.toFixed(2);
        }

        var gebiedNaam = data.content["gebied-naam"];
        if (typeof gebiedNaam === "undefined") {
          gebiedNaam = "";
        }

        var model = {
          algemeenGisratioid: data.content["algemeen-gisratioid"],
          beheereenheidNaam: data.content["beheereenheid-naam"],
          laag: data.content["algemeen-laag"],
          gebiedsCode: "",
          gebiedNaam: gebiedNaam,
          discipline: disNaam,
          prestatie: algemeenPrestatie,
          horizon: horizon,
          startDate: startDate,
          endDate: endDate,
          identification: data.identification,
        };
        window.$mm_management_units_Glist.push(model);

        var test = {
          checkbox: checkbox,
          active: circleType,
          "Gisratio ID": algemeenGisratioid,
          "Naam beheereenheid": beheereenheidNaam,
          "Discipline naam": disNaam,
          Horizon: horizon,
          "GIS laag naam": gebiedLaag,
          Prestatie: algemeenPrestatie,
          Gebiedsnaam: gebiedNaam,
        };

        var _columnList = [];
        if (columnList && columnList.column_list){
          for (let column in columnList.column_list) {
            for (let key in test) {
              if (
                  columnList.column_list[column].toLowerCase() === key.toLowerCase()
              ) {
                _columnList.push(test[key]);
              }
            }
          }
        }

        var addId = oTable.fnAddData(
          [
            // checkbox,
            // circleType,
            ..._columnList,
            // algemeenGisratioid,
            // beheereenheidNaam,
            // disNaam,
            // horizon,
            // gebiedLaag,
            // algemeenPrestatie,
            // gebiedNaam,
          ],
          false
        );

        var theNode = $("#example").dataTable().fnSettings().aoData[
          addId[0]
        ].nTr;
        theNode.setAttribute("rowId", data["identification"]);
      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }
  $("#cover-spin").hide(0);
  // that.setState({ loading: false });
  $("#total-rows").html(result.meta.total_found);
  window.$mm_management_units_table_total_row_count = result.meta.total_found;
  window.$mm_management_units_gvv = 0;
  window.$mm_management_units_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id == "algemeen-gisratioid") {
    $.each(result.data.values, function (index, data) {
      window.$mm_management_units_algemeenGisratioid.push(data);
    });
  } else if (data.id == "beheereenheid-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_management_units_beheereenheidNaam.push(data);
    });
  } else if (data.id == "discipline-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_management_units_disciplineNaam.push(data);
    });
  } else if (data.id == "gebied-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_management_units_gebiedNaam.push(data);
    });
  } else if (data.id == "algemeen-laag") {
    $.each(result.data.values, function (index, data) {
      window.$mm_management_units_algemeenLaag.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-gisratioid") {
    window.$mm_management_units_algemeenGisratioid.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_management_units_algemeenGisratioid.push(data);
    });
  } else if (searchId === "beheereenheid-naam") {
    window.$mm_management_units_beheereenheidNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_management_units_beheereenheidNaam.push(data);
    });
  } else if (searchId === "discipline-naam") {
    window.$mm_management_units_disciplineNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_management_units_disciplineNaam.push(data);
    });
  } else if (searchId === "gebied-naam") {
    window.$mm_management_units_gebiedNaam.lenght = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_management_units_gebiedNaam.push(data);
    });
  } else if (searchId === "algemeen-laag") {
    window.$mm_management_units_algemeenLaag.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_management_units_algemeenLaag.push(data);
    });
  }
};

export const beheereenheidSavedCallBack = (token) => {};
function beheereenheidSavedNext(token) {}

export const BeheereenheidEditCallBack = (token) => {};

export const RowsDeletedCallBack = (token) => {};

export const GetActionsOfRowCallback = (result) => {
  var actionsOfSelection = [];
  // var actionsOfDisabled = [];
  // $.each(result.data.stages, function (index, stage) {
  //   if (stage.definition.type == "activity" && stage.start_allowed == true) {
  //     actionsOfSelection.push(stage.definition.identification);
  //   } else {
  //     actionsOfDisabled.push(stage.definition);
  //   }
  // });

  $("#myPopup").html("");
  if(GetSelected().length > 0){
    $.each(window.$mm_management_units_actions, function (index, action) {
      if ($.inArray(action["id"], result) !== -1) {
        var anchor = $("<a></a>")
            .attr({ role: "button", id: action["id"] })
            .addClass(action["class"] + " action")
            .html(action["text"]);
        $("#myPopup").append(anchor);
      }
    });
  }
  //** aktif olmayan actionlar burada listeleniyor. */
  // $.each(actionsOfDisabled, function (index, action) {
  //   var anchor = $("<a disabled></a>")
  //     .attr({ href: "javascript:void(0)", id: action["identification"] })
  //     .addClass("disabled" + " catalog-action")
  //     .html(action["name"]);
  //   $("#myPopup").append(anchor);
  // });
  var toonOpKaart = $("<a></a>")
    .attr({ role: "button", id: "mu_toon_dossiers_op_kaart" })
    .addClass("locate action")
    .html("Toon op kaart");
  $("#myPopup").append(toonOpKaart);

  var overzichtObject = $("<a></a>")
    .attr({ role: "button", id: "mu_overzicht_object" })
    .addClass("locate action")
    .html("Overzicht object");
  $("#myPopup").append(overzichtObject);

  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};

// export const GrpCallBack = (divId, nameId, result, pageNumber) => {};
export const GrpCallBack = (divId, nameId, result, pageNumber) => {
  if (pageNumber == 0) {
    $("#" + divId).html("");
  }
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="' +
      nameId +
      '"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#" + divId).append(btn);
  });
};
